import React from "react";
import { Formik } from "formik";
import Yup from "yup";
import styled from "styled-components";
import { media } from "../../utils/style";
import Fieldset from "../Fieldset";
import Button from "../Button";
import spaceDust from "../../images/space-dust-3.png";

const Form = styled.form`
  background: #262168;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.35);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin: 0;
  max-width: 400px;
  padding: 15px 20px 20px;
  position: relative;
  width: 100%;

  &:after {
    background-image: url(${spaceDust});
    background-repeat: no-repeat;
    background-size: contain;
    content: "";
    height: 2441px;
    position: absolute;
    right: -750px;
    top: -700px;
    width: 1796px;
    z-index: -1;
  }

  ${media.tablet`
    margin-left: 20px;
    padding: 35px 40px 40px;
  `};
`;

const ForgotPasswordForm = props => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit
  } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Fieldset
        id="email"
        type="email"
        label="Your Email"
        placeholder="name@example.com"
        error={touched.email && errors.email}
        value={values.email}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Button type="submit">Send Reset Email</Button>
    </Form>
  );
};

export default Formik({
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email("Email must be valid")
      .required("Email is required")
  }),
  mapPropsToValues: props => {
    return {
      email: ""
    };
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.handleSubmit(values, resetForm);
  },
  validateOnChange: true
})(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordForm/index.jsx